/**
 * Returns true for paths that are served as pure server-rendered HTML with no
 * Vike client bundle (injectScriptsAt: null). Vike's soft navigate() and React
 * hydration must never be used for these routes — the page must always be
 * fetched fresh from the server.
 *
 * Matched sets:
 *   - Landing pages:  `/en`, `/fi`, `/sv` (`/` 301 → `/en`)
 *   - Resource hubs:  /en/resources/*, /fi/tyoelama/*, /sv/arbetsliv/*
 *   - Company pages (English slugs):  /about, /partnerships, /privacy, /terms,
 *                                     /accessibility-statement
 *   - Company pages (Finnish slugs):  /fi/tietoa-jobcrawlsista, /fi/kumppanuudet,
 *                                     /fi/tietosuoja, /fi/toimitusperiaatteet, /fi/yhteystiedot,
 *                                     /fi/saavutettavuusseloste
 *   - Company pages (Swedish slugs):  /sv/om-jobcrawls, /sv/partnerskap,
 *                                     /sv/integritet, /sv/redaktionella-riktlinjer, /sv/kontakt,
 *                                     /sv/tillganglighetsutlatande
 *   - Terms: English only at /en/terms (no /fi/kayttoehdot or /sv/villkor)
 */
export function isStaticDestination(path: string): boolean {
  // Landing pages: /en, /fi, /sv (with optional trailing slash). Root / is a CDN redirect.
  if (/^\/(en|fi|sv)\/?$/.test(path)) return true;

  // Resource hubs and all sub-pages (each language tree has injectScriptsAt: null)
  if (/^\/(en\/resources|fi\/tyoelama|sv\/arbetsliv)(\/|$)/.test(path)) return true;

  // Job-search guide hubs (prerendered in web-static)
  if (/^\/(en\/job-search|fi\/tyonhaku|sv\/jobbsok)(\/|$)/.test(path)) return true;

  // Company/policy pages — English slugs with optional locale prefix
  if (
    /^\/(en|fi|sv)?\/?(?:about|partnerships|privacy|terms|editorial-standards|contact|accessibility-statement)(\/|$)/.test(
      path,
    )
  )
    return true;

  // Company/policy pages — Finnish localised slugs
  if (
    /^\/fi\/(tietoa-jobcrawlsista|kumppanuudet|tietosuoja|toimitusperiaatteet|yhteystiedot|saavutettavuusseloste)(\/|$)/.test(
      path,
    )
  )
    return true;

  // Company/policy pages — Swedish localised slugs
  if (
    /^\/sv\/(om-jobcrawls|partnerskap|integritet|redaktionella-riktlinjer|kontakt|tillganglighetsutlatande)(\/|$)/.test(
      path,
    )
  )
    return true;

  return false;
}
